/* eslint-disable no-undef */

// Routes
import { ClientRoutes, LoginRoutes } from '../Routes';

// Stores
import CurrencyStore from './CurrencyStore';

// Libraries
var jwt_decode = require('jwt-decode');
var {EventEmitter} = require('fbemitter');
var emitter = new EventEmitter();

// Given a token, expand it and store the user / token in sessionStorage
function addUser(token) {

    //console.log('UserProfileStore.addUser()');

    var decoded = jwt_decode(token);
    var user = decoded.user;

    // Clear previous session user
    sessionStorage.clear();

    sessionStorage.setItem('token', token);
    sessionStorage.setItem('user', JSON.stringify(user));

}


// Removes a user from sessionStorage and clears their token server side
function removeUser() {

    //console.log('UserProfileStore.removeUser()');

    var token = sessionStorage.getItem('token');

    sessionStorage.clear();

    return new Promise ( (resolve, reject) => {

        LoginRoutes.logout(token)
            .then( (success) => {

                resolve(true);

            }).catch( (error) => {

                resolve(true);

            });

    });

}


// Retrieves the user from sessionStorage
function getUser() {

    //console.log('UserProfileStore.getUser()');

    var token = sessionStorage.getItem('token');

    if(token !== null) {

        if(validateSession(token))
            return JSON.parse(sessionStorage.getItem('user'));
        else
            return null;
    }
    else {
        return null;
    }

}


// Returns the user's token if it exists
function getToken() {

    //console.log('UserProfileStore.getToken()');

    return sessionStorage.getItem('token');

}


// Returns the emitter
function getEmitter() {

    return emitter;
}


// Returns a user's pnl object.  If not available and logged in,
// retrieve it, cache it and return it
function getPnl(refresh) {

    //console.log('UserProfileStore.getPnl()');

    var pnl = sessionStorage.getItem('pnl');

    if(pnl == null || pnl === "null" || refresh) {

        // indicate to listeners that pnl is loading
        emitter.emit('loadingPnl', true);

        const user = getUser();

        ClientRoutes.getPnl(user.username)
            .then( (pnlObject) => {

                sessionStorage.setItem('pnl', JSON.stringify(pnlObject.pnl));

                emitter.emit('pnl', true);

            }).catch( (error) => {

                // store pnl error
                sessionStorage.setItem('pnl', null);
                sessionStorage.setItem('pnlError', JSON.stringify(error));

                emitter.emit('pnl', false);

            });

    }
    else {

        // pnl already exists, notify listeners
        emitter.emit('pnl', true);

    }

}


// Returns the pnlError
function getPnlError() {

    //console.log('UserProfileStore.getPnlError()');
    
    var error = sessionStorage.getItem('pnlError');

    return JSON.parse(error);

}


// Returns the histPnlError
function getHistPnlError() {
    
    //console.log('UserProfileStore.getHistPnlError()');
    
    var error = sessionStorage.getItem('histPnlError');

    return JSON.parse(error);

}


// Returns the details for overview
function getOverview() {

    //console.log('UserProfileStore.getOverview()');

    const pnl = sessionStorage.getItem('pnl');

    if(pnl === null || pnl === "null") {
        return null;
    }
    else {
        const parsed = JSON.parse(pnl);

        var overview = {};

        // build overview data for USD, BTC
        for(let [quoteCurrency, details] of Object.entries(parsed)) {

            overview[quoteCurrency] = buildOverview(details.exchangeSummary, details.exchangeDetailed, quoteCurrency);

        }

        return overview;
        
    }
 
}


// Given the pnl exchange summary, return the built overview object
function buildOverview(exchangeSummary, exchangeDetailed, quoteCurrency) {

    var overview = {};
    
    for(let[exchange, details] of Object.entries(exchangeSummary)) {
        var newEx = {
            // today
            'dailyPnl' : parseFloat(details["dailyPnl"]),
            'dailyChange' : parseFloat(details["dailyPer"]),
            // since signup
            'totalPnl' : parseFloat(details["inceptionPnl"]),
            'totalChange' : parseFloat(details["inceptionPer"]),
            // other
            'position' : parseFloat(details["position"]),
            'quoteCurrency' : quoteCurrency,
            'holdings' : buildExchangeHoldings(exchangeDetailed[exchange].data, quoteCurrency)

        };

        overview[exchange] = newEx;
    }

    return overview;
}


// Returns the details for overview
function getHoldings(user) {
    
    //console.log('UserProfileStore.getHoldings()');
    
    const pnl = sessionStorage.getItem('pnl');
    
    if(pnl === null || pnl === "null") {
        return null;
    }
    else {
        const parsed = JSON.parse(pnl);

        var holdings = {};

        // build holdings data for usd
        for(let [quoteCurrency, details] of Object.entries(parsed)) {

            holdings[quoteCurrency] = buildHoldings(details.exchangeDetailed, quoteCurrency);
            holdings[quoteCurrency]['All'] = summarizeHoldings(details.coinSummary, quoteCurrency); // all exchanges

        }

        return holdings;
        
    }    

}


// Given only the holdings for a specific exchange, return them formatted
function buildExchangeHoldings(exchangeDetailed, quoteCurrency) {

    var holdings = {};
    const minPosition = quoteCurrency === 'USD' ? 1 : 0.00001;

    for(let [ticker, details] of Object.entries(exchangeDetailed)) {

        // If more than $1 of coin, then add to list
        if(details.position > minPosition) {

            const coin = {
                // today
                dailyPnl : details.dailyPnl,
                dailyChange : details.dailyPer,
                // since signup
                totalPnl : details.inceptionPnl,
                totalChange : details.inceptionPer,
                // others
                position : details.position,
                quantity : details.quantity,
                ticker : ticker,
                name : CurrencyStore.getCoinName(ticker)
            };

            holdings[ticker] = coin;

        }
    }

    return holdings;

}

// Given the exchange detailed from pnl, return a holdings by currency and exchange
function buildHoldings(exchangeDetailed, quoteCurrency, exchange) {

    var holdings = {};
    const minPosition = quoteCurrency === 'USD' ? 1 : 0.00001;

    for(let [exchange, exchangeDetails] of Object.entries(exchangeDetailed)) {

        holdings[exchange] = {};

        for(let [ticker, details] of Object.entries(exchangeDetails.data)) {

            // If more than $1 of coin, then add to list
            if(details.position > minPosition) {

                const coin = {
                    // today
                    dailyPnl : details.dailyPnl,
                    dailyChange : details.dailyPer,
                    // since signup
                    totalPnl : details.inceptionPnl,
                    totalChange : details.inceptionPer,
                    // others
                    position : details.position,
                    quantity : details.quantity,
                    ticker : ticker,
                    name : CurrencyStore.getCoinName(ticker)
                };

                holdings[exchange][ticker] = coin;

            }
        }
        
    }

    return holdings;

}


function summarizeHoldings(coinSummary, quoteCurrency) {

    var allCoins = {};
    const minPosition = quoteCurrency === 'USD' ? 1 : 0.00001;

    for(let [ticker, details] of Object.entries(coinSummary)) {

        // If more than $1 of coin, then add to list
        if(details.position > minPosition) {

            const coin = {
                // today
                dailyPnl : details.dailyPnl,
                dailyChange : details.dailyPer,
                // inception
                totalPnl : details.inceptionPnl,
                totalChange : details.inceptionPer,
                // others
                position : details.position,
                quantity : details.quantity,
                ticker : ticker,
                name : CurrencyStore.getCoinName(ticker)
            };

            allCoins[ticker] = coin;

        }

    }

    return allCoins;

}


// Returns the open orders for the given user
function getOrders(refresh) {

    return new Promise( (resolve, reject) => {

        var orders = sessionStorage.getItem('orders');

        // Retrieve fresh orders
        if(orders === null || refresh) {

            var user = this.getUser();
    
            ClientRoutes.getOrders(user.username)
                .then( (orders) => {

                    // store orders
                    sessionStorage.setItem('orders', JSON.stringify(orders));
        
                    resolve(orders);

                }).catch( (error) => {
        
                    if(error.data === 'Unauthorized Request') {
                        removeUser();
                    }

                    // return error object exactly as it arrives
                    reject(error);
                });

        }
        else {
            // Return cached orders
            resolve(JSON.parse(orders));

        }

    });

}


// Returns the open positions for a given user
function getPositions(refresh) {

    return new Promise( (resolve, reject) => {
        
        var positions = sessionStorage.getItem('positions');

        // Retrieve fresh positions
        if(positions === null || refresh) {

            var user = this.getUser();
    
            ClientRoutes.getPositions(user.username)
                .then( (positions) => {

                    // store positions
                    sessionStorage.setItem('positions', JSON.stringify(positions));
        
                    resolve(positions);

                }).catch( (error) => {
        
                    if(error.data === 'Unauthorized Request') {
                        removeUser();
                    }

                    // return error object exactly as it arrives
                    reject(error);
                });

        }
        else {
            // Return cached orders
            resolve(JSON.parse(positions));

        }

    });

}

// Returns the hist pnl
function getHistPnl(refresh, days) {

    //console.log('UserProfileStore.getHistPnl()');

    // Check cache for hist pnl
    var histPnl = sessionStorage.getItem('histPnl');

    // Balances already exist, return them
    if(histPnl === null || histPnl === "null" || refresh) {

        // indicate to listeners that histPnl is loading
        emitter.emit('loadingHistPnl', true);

        var user = getUser();

        ClientRoutes.getHistPnl(user.username, days)
            .then( (histPnl) => {

                // store histpnl
                sessionStorage.setItem('histPnl', JSON.stringify(histPnl));

                emitter.emit('histPnl', true);

            }).catch( (error) => {

                if(error.data === 'Unauthorized Request') {
                    removeUser();
                }

                // store pnl error
                sessionStorage.setItem('histPnl', null);
                sessionStorage.setItem('histPnlError', JSON.stringify(error));

                emitter.emit('histPnl', false);

            });
        
    }
    else {
        emitter.emit('histPnl', true);
    }

}


// Returns the historical pnl exchange summaries
function getHistExchangeSummaries() {

    //console.log('UserProfileStore.getHistExchangeSummaries()');
 
    const histPnl = sessionStorage.getItem('histPnl');
    
    if(histPnl === null || histPnl === "null") {
        //sessionStorage.setItem('histPnlError', JSON.stringify({'message':'no historical pnl', 'data':'no historical pnl'}));
        //emitter.emit('histPnl', false);
        return null;
    }
    else {
        const parsed = JSON.parse(histPnl);

        var newHistExchangeSummaries = {
            'BTC' : {},
            'USD' : {}
        };

        for(let[timestamp, details] of Object.entries(parsed)) {

            if(details.hasOwnProperty('pnl') && details.complete) {
                newHistExchangeSummaries['USD'][timestamp] = details.pnl['USD'].exchangeSummary;
                newHistExchangeSummaries['BTC'][timestamp] = details.pnl['BTC'].exchangeSummary;
            }
            
        }

        if(Object.entries(newHistExchangeSummaries['BTC']).length === 0 &&
        Object.entries(newHistExchangeSummaries['USD']).length === 0) {
            sessionStorage.setItem('histPnlError', JSON.stringify({'message':'no historical pnl', 'data':'No Historical Pnl'}));
            emitter.emit('histPnl', false);
            return null;
        }
        else
            return newHistExchangeSummaries;
        
    } 

}


// Returns the historical pnl exchange summaries
function getHistCurrencies() {
    
    //console.log('UserProfileStore.getHistCurrencies()');

    const histPnl = sessionStorage.getItem('histPnl');
       
    if(histPnl === null || histPnl === "null") {
        return null;
    }
    else {
        const parsed = JSON.parse(histPnl);

        var newHistCurrencies = {
            'BTC' : {},
            'USD' : {}
        };

        for(let[timestamp, details] of Object.entries(parsed)) {

            if(details.hasOwnProperty('pnl') && details.complete) {
                newHistCurrencies['USD'][timestamp] = details.pnl['USD'].pnlToDate;
                newHistCurrencies['BTC'][timestamp] = details.pnl['BTC'].pnlToDate;
            }
        }

        return newHistCurrencies;
        
    } 

}


// Validates a user's token
function validateSession(token) {

    var decoded = jwt_decode(token);

    // check if token has expired
    var createdAt = decoded.iat;
    var sessionLength = decoded.exp;  // 60 * 60 = 1hr
    var currentTime = Math.floor(Date.now() / 1000);

    // Token has expired, clear storage and remove token from server
    if(currentTime - createdAt > sessionLength) {

        removeUser();
    }
    else
        return true;

}


const UserProfileStore = { addUser, removeUser, getUser, getToken, getPnl,
    getOrders, getPositions, getOverview, getHoldings, getHistPnl, 
    getHistExchangeSummaries, getHistCurrencies, getEmitter, getPnlError, getHistPnlError };

export default UserProfileStore;






// WEBPACK FOOTER //
// ./src/Stores/UserProfileStore.js